/**
 * @fileoverview gRPC-Web generated client stub for dualcam
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v7.36.0
// source: dualcam.proto


/* eslint-disable no-unused-vars */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')
const proto = {};
proto.dualcam = require('./dualcam_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.dualcam.DualcamServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.dualcam.DualcamServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dualcam.LoginRequest,
 *   !proto.dualcam.LoginResponse>}
 */
const methodDescriptor_DualcamService_Login = new grpc.web.MethodDescriptor(
  '/dualcam.DualcamService/Login',
  grpc.web.MethodType.UNARY,
  proto.dualcam.LoginRequest,
  proto.dualcam.LoginResponse,
  /**
   * @param {!proto.dualcam.LoginRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dualcam.LoginResponse.deserializeBinary
);


/**
 * @param {!proto.dualcam.LoginRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dualcam.LoginResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dualcam.LoginResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dualcam.DualcamServiceClient.prototype.login =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dualcam.DualcamService/Login',
      request,
      metadata || {},
      methodDescriptor_DualcamService_Login,
      callback);
};


/**
 * @param {!proto.dualcam.LoginRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dualcam.LoginResponse>}
 *     Promise that resolves to the response
 */
proto.dualcam.DualcamServicePromiseClient.prototype.login =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dualcam.DualcamService/Login',
      request,
      metadata || {},
      methodDescriptor_DualcamService_Login);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dualcam.RefreshTokenRequest,
 *   !proto.dualcam.LoginResponse>}
 */
const methodDescriptor_DualcamService_RefreshToken = new grpc.web.MethodDescriptor(
  '/dualcam.DualcamService/RefreshToken',
  grpc.web.MethodType.UNARY,
  proto.dualcam.RefreshTokenRequest,
  proto.dualcam.LoginResponse,
  /**
   * @param {!proto.dualcam.RefreshTokenRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dualcam.LoginResponse.deserializeBinary
);


/**
 * @param {!proto.dualcam.RefreshTokenRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dualcam.LoginResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dualcam.LoginResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dualcam.DualcamServiceClient.prototype.refreshToken =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dualcam.DualcamService/RefreshToken',
      request,
      metadata || {},
      methodDescriptor_DualcamService_RefreshToken,
      callback);
};


/**
 * @param {!proto.dualcam.RefreshTokenRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dualcam.LoginResponse>}
 *     Promise that resolves to the response
 */
proto.dualcam.DualcamServicePromiseClient.prototype.refreshToken =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dualcam.DualcamService/RefreshToken',
      request,
      metadata || {},
      methodDescriptor_DualcamService_RefreshToken);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dualcam.ListAlbumsRequest,
 *   !proto.dualcam.AlbumList>}
 */
const methodDescriptor_DualcamService_ListAlbums = new grpc.web.MethodDescriptor(
  '/dualcam.DualcamService/ListAlbums',
  grpc.web.MethodType.UNARY,
  proto.dualcam.ListAlbumsRequest,
  proto.dualcam.AlbumList,
  /**
   * @param {!proto.dualcam.ListAlbumsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dualcam.AlbumList.deserializeBinary
);


/**
 * @param {!proto.dualcam.ListAlbumsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dualcam.AlbumList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dualcam.AlbumList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dualcam.DualcamServiceClient.prototype.listAlbums =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dualcam.DualcamService/ListAlbums',
      request,
      metadata || {},
      methodDescriptor_DualcamService_ListAlbums,
      callback);
};


/**
 * @param {!proto.dualcam.ListAlbumsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dualcam.AlbumList>}
 *     Promise that resolves to the response
 */
proto.dualcam.DualcamServicePromiseClient.prototype.listAlbums =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dualcam.DualcamService/ListAlbums',
      request,
      metadata || {},
      methodDescriptor_DualcamService_ListAlbums);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dualcam.AddAlbumRequest,
 *   !proto.dualcam.Album>}
 */
const methodDescriptor_DualcamService_AddAlbum = new grpc.web.MethodDescriptor(
  '/dualcam.DualcamService/AddAlbum',
  grpc.web.MethodType.UNARY,
  proto.dualcam.AddAlbumRequest,
  proto.dualcam.Album,
  /**
   * @param {!proto.dualcam.AddAlbumRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dualcam.Album.deserializeBinary
);


/**
 * @param {!proto.dualcam.AddAlbumRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dualcam.Album)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dualcam.Album>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dualcam.DualcamServiceClient.prototype.addAlbum =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dualcam.DualcamService/AddAlbum',
      request,
      metadata || {},
      methodDescriptor_DualcamService_AddAlbum,
      callback);
};


/**
 * @param {!proto.dualcam.AddAlbumRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dualcam.Album>}
 *     Promise that resolves to the response
 */
proto.dualcam.DualcamServicePromiseClient.prototype.addAlbum =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dualcam.DualcamService/AddAlbum',
      request,
      metadata || {},
      methodDescriptor_DualcamService_AddAlbum);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dualcam.UpdateAlbumRequest,
 *   !proto.dualcam.Album>}
 */
const methodDescriptor_DualcamService_UpdateAlbum = new grpc.web.MethodDescriptor(
  '/dualcam.DualcamService/UpdateAlbum',
  grpc.web.MethodType.UNARY,
  proto.dualcam.UpdateAlbumRequest,
  proto.dualcam.Album,
  /**
   * @param {!proto.dualcam.UpdateAlbumRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dualcam.Album.deserializeBinary
);


/**
 * @param {!proto.dualcam.UpdateAlbumRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dualcam.Album)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dualcam.Album>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dualcam.DualcamServiceClient.prototype.updateAlbum =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dualcam.DualcamService/UpdateAlbum',
      request,
      metadata || {},
      methodDescriptor_DualcamService_UpdateAlbum,
      callback);
};


/**
 * @param {!proto.dualcam.UpdateAlbumRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dualcam.Album>}
 *     Promise that resolves to the response
 */
proto.dualcam.DualcamServicePromiseClient.prototype.updateAlbum =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dualcam.DualcamService/UpdateAlbum',
      request,
      metadata || {},
      methodDescriptor_DualcamService_UpdateAlbum);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dualcam.DeleteAlbumRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_DualcamService_DeleteAlbum = new grpc.web.MethodDescriptor(
  '/dualcam.DualcamService/DeleteAlbum',
  grpc.web.MethodType.UNARY,
  proto.dualcam.DeleteAlbumRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.dualcam.DeleteAlbumRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.dualcam.DeleteAlbumRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dualcam.DualcamServiceClient.prototype.deleteAlbum =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dualcam.DualcamService/DeleteAlbum',
      request,
      metadata || {},
      methodDescriptor_DualcamService_DeleteAlbum,
      callback);
};


/**
 * @param {!proto.dualcam.DeleteAlbumRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.dualcam.DualcamServicePromiseClient.prototype.deleteAlbum =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dualcam.DualcamService/DeleteAlbum',
      request,
      metadata || {},
      methodDescriptor_DualcamService_DeleteAlbum);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dualcam.GetAlbumMediaRequest,
 *   !proto.dualcam.MediaList>}
 */
const methodDescriptor_DualcamService_GetAlbumMedia = new grpc.web.MethodDescriptor(
  '/dualcam.DualcamService/GetAlbumMedia',
  grpc.web.MethodType.UNARY,
  proto.dualcam.GetAlbumMediaRequest,
  proto.dualcam.MediaList,
  /**
   * @param {!proto.dualcam.GetAlbumMediaRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dualcam.MediaList.deserializeBinary
);


/**
 * @param {!proto.dualcam.GetAlbumMediaRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dualcam.MediaList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dualcam.MediaList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dualcam.DualcamServiceClient.prototype.getAlbumMedia =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dualcam.DualcamService/GetAlbumMedia',
      request,
      metadata || {},
      methodDescriptor_DualcamService_GetAlbumMedia,
      callback);
};


/**
 * @param {!proto.dualcam.GetAlbumMediaRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dualcam.MediaList>}
 *     Promise that resolves to the response
 */
proto.dualcam.DualcamServicePromiseClient.prototype.getAlbumMedia =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dualcam.DualcamService/GetAlbumMedia',
      request,
      metadata || {},
      methodDescriptor_DualcamService_GetAlbumMedia);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dualcam.GetAlbumStatsRequest,
 *   !proto.dualcam.AlbumStats>}
 */
const methodDescriptor_DualcamService_GetAlbumStats = new grpc.web.MethodDescriptor(
  '/dualcam.DualcamService/GetAlbumStats',
  grpc.web.MethodType.UNARY,
  proto.dualcam.GetAlbumStatsRequest,
  proto.dualcam.AlbumStats,
  /**
   * @param {!proto.dualcam.GetAlbumStatsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dualcam.AlbumStats.deserializeBinary
);


/**
 * @param {!proto.dualcam.GetAlbumStatsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dualcam.AlbumStats)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dualcam.AlbumStats>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dualcam.DualcamServiceClient.prototype.getAlbumStats =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dualcam.DualcamService/GetAlbumStats',
      request,
      metadata || {},
      methodDescriptor_DualcamService_GetAlbumStats,
      callback);
};


/**
 * @param {!proto.dualcam.GetAlbumStatsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dualcam.AlbumStats>}
 *     Promise that resolves to the response
 */
proto.dualcam.DualcamServicePromiseClient.prototype.getAlbumStats =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dualcam.DualcamService/GetAlbumStats',
      request,
      metadata || {},
      methodDescriptor_DualcamService_GetAlbumStats);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dualcam.CheckUploadNamesRequest,
 *   !proto.dualcam.DuplicateMatchList>}
 */
const methodDescriptor_DualcamService_CheckUploadNames = new grpc.web.MethodDescriptor(
  '/dualcam.DualcamService/CheckUploadNames',
  grpc.web.MethodType.UNARY,
  proto.dualcam.CheckUploadNamesRequest,
  proto.dualcam.DuplicateMatchList,
  /**
   * @param {!proto.dualcam.CheckUploadNamesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dualcam.DuplicateMatchList.deserializeBinary
);


/**
 * @param {!proto.dualcam.CheckUploadNamesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dualcam.DuplicateMatchList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dualcam.DuplicateMatchList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dualcam.DualcamServiceClient.prototype.checkUploadNames =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dualcam.DualcamService/CheckUploadNames',
      request,
      metadata || {},
      methodDescriptor_DualcamService_CheckUploadNames,
      callback);
};


/**
 * @param {!proto.dualcam.CheckUploadNamesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dualcam.DuplicateMatchList>}
 *     Promise that resolves to the response
 */
proto.dualcam.DualcamServicePromiseClient.prototype.checkUploadNames =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dualcam.DualcamService/CheckUploadNames',
      request,
      metadata || {},
      methodDescriptor_DualcamService_CheckUploadNames);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dualcam.ShareAlbumRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_DualcamService_ShareAlbum = new grpc.web.MethodDescriptor(
  '/dualcam.DualcamService/ShareAlbum',
  grpc.web.MethodType.UNARY,
  proto.dualcam.ShareAlbumRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.dualcam.ShareAlbumRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.dualcam.ShareAlbumRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dualcam.DualcamServiceClient.prototype.shareAlbum =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dualcam.DualcamService/ShareAlbum',
      request,
      metadata || {},
      methodDescriptor_DualcamService_ShareAlbum,
      callback);
};


/**
 * @param {!proto.dualcam.ShareAlbumRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.dualcam.DualcamServicePromiseClient.prototype.shareAlbum =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dualcam.DualcamService/ShareAlbum',
      request,
      metadata || {},
      methodDescriptor_DualcamService_ShareAlbum);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dualcam.ListAlbumSharesRequest,
 *   !proto.dualcam.AlbumShareList>}
 */
const methodDescriptor_DualcamService_ListAlbumShares = new grpc.web.MethodDescriptor(
  '/dualcam.DualcamService/ListAlbumShares',
  grpc.web.MethodType.UNARY,
  proto.dualcam.ListAlbumSharesRequest,
  proto.dualcam.AlbumShareList,
  /**
   * @param {!proto.dualcam.ListAlbumSharesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dualcam.AlbumShareList.deserializeBinary
);


/**
 * @param {!proto.dualcam.ListAlbumSharesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dualcam.AlbumShareList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dualcam.AlbumShareList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dualcam.DualcamServiceClient.prototype.listAlbumShares =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dualcam.DualcamService/ListAlbumShares',
      request,
      metadata || {},
      methodDescriptor_DualcamService_ListAlbumShares,
      callback);
};


/**
 * @param {!proto.dualcam.ListAlbumSharesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dualcam.AlbumShareList>}
 *     Promise that resolves to the response
 */
proto.dualcam.DualcamServicePromiseClient.prototype.listAlbumShares =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dualcam.DualcamService/ListAlbumShares',
      request,
      metadata || {},
      methodDescriptor_DualcamService_ListAlbumShares);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dualcam.RevokeShareRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_DualcamService_RevokeShare = new grpc.web.MethodDescriptor(
  '/dualcam.DualcamService/RevokeShare',
  grpc.web.MethodType.UNARY,
  proto.dualcam.RevokeShareRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.dualcam.RevokeShareRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.dualcam.RevokeShareRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dualcam.DualcamServiceClient.prototype.revokeShare =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dualcam.DualcamService/RevokeShare',
      request,
      metadata || {},
      methodDescriptor_DualcamService_RevokeShare,
      callback);
};


/**
 * @param {!proto.dualcam.RevokeShareRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.dualcam.DualcamServicePromiseClient.prototype.revokeShare =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dualcam.DualcamService/RevokeShare',
      request,
      metadata || {},
      methodDescriptor_DualcamService_RevokeShare);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dualcam.CreatePublicShareRequest,
 *   !proto.dualcam.PublicShare>}
 */
const methodDescriptor_DualcamService_CreatePublicShare = new grpc.web.MethodDescriptor(
  '/dualcam.DualcamService/CreatePublicShare',
  grpc.web.MethodType.UNARY,
  proto.dualcam.CreatePublicShareRequest,
  proto.dualcam.PublicShare,
  /**
   * @param {!proto.dualcam.CreatePublicShareRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dualcam.PublicShare.deserializeBinary
);


/**
 * @param {!proto.dualcam.CreatePublicShareRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dualcam.PublicShare)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dualcam.PublicShare>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dualcam.DualcamServiceClient.prototype.createPublicShare =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dualcam.DualcamService/CreatePublicShare',
      request,
      metadata || {},
      methodDescriptor_DualcamService_CreatePublicShare,
      callback);
};


/**
 * @param {!proto.dualcam.CreatePublicShareRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dualcam.PublicShare>}
 *     Promise that resolves to the response
 */
proto.dualcam.DualcamServicePromiseClient.prototype.createPublicShare =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dualcam.DualcamService/CreatePublicShare',
      request,
      metadata || {},
      methodDescriptor_DualcamService_CreatePublicShare);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dualcam.ListPublicSharesRequest,
 *   !proto.dualcam.PublicShareList>}
 */
const methodDescriptor_DualcamService_ListPublicShares = new grpc.web.MethodDescriptor(
  '/dualcam.DualcamService/ListPublicShares',
  grpc.web.MethodType.UNARY,
  proto.dualcam.ListPublicSharesRequest,
  proto.dualcam.PublicShareList,
  /**
   * @param {!proto.dualcam.ListPublicSharesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dualcam.PublicShareList.deserializeBinary
);


/**
 * @param {!proto.dualcam.ListPublicSharesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dualcam.PublicShareList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dualcam.PublicShareList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dualcam.DualcamServiceClient.prototype.listPublicShares =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dualcam.DualcamService/ListPublicShares',
      request,
      metadata || {},
      methodDescriptor_DualcamService_ListPublicShares,
      callback);
};


/**
 * @param {!proto.dualcam.ListPublicSharesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dualcam.PublicShareList>}
 *     Promise that resolves to the response
 */
proto.dualcam.DualcamServicePromiseClient.prototype.listPublicShares =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dualcam.DualcamService/ListPublicShares',
      request,
      metadata || {},
      methodDescriptor_DualcamService_ListPublicShares);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dualcam.ListAllPublicSharesRequest,
 *   !proto.dualcam.PublicShareList>}
 */
const methodDescriptor_DualcamService_ListAllPublicShares = new grpc.web.MethodDescriptor(
  '/dualcam.DualcamService/ListAllPublicShares',
  grpc.web.MethodType.UNARY,
  proto.dualcam.ListAllPublicSharesRequest,
  proto.dualcam.PublicShareList,
  /**
   * @param {!proto.dualcam.ListAllPublicSharesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dualcam.PublicShareList.deserializeBinary
);


/**
 * @param {!proto.dualcam.ListAllPublicSharesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dualcam.PublicShareList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dualcam.PublicShareList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dualcam.DualcamServiceClient.prototype.listAllPublicShares =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dualcam.DualcamService/ListAllPublicShares',
      request,
      metadata || {},
      methodDescriptor_DualcamService_ListAllPublicShares,
      callback);
};


/**
 * @param {!proto.dualcam.ListAllPublicSharesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dualcam.PublicShareList>}
 *     Promise that resolves to the response
 */
proto.dualcam.DualcamServicePromiseClient.prototype.listAllPublicShares =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dualcam.DualcamService/ListAllPublicShares',
      request,
      metadata || {},
      methodDescriptor_DualcamService_ListAllPublicShares);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dualcam.RevokePublicShareRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_DualcamService_RevokePublicShare = new grpc.web.MethodDescriptor(
  '/dualcam.DualcamService/RevokePublicShare',
  grpc.web.MethodType.UNARY,
  proto.dualcam.RevokePublicShareRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.dualcam.RevokePublicShareRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.dualcam.RevokePublicShareRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dualcam.DualcamServiceClient.prototype.revokePublicShare =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dualcam.DualcamService/RevokePublicShare',
      request,
      metadata || {},
      methodDescriptor_DualcamService_RevokePublicShare,
      callback);
};


/**
 * @param {!proto.dualcam.RevokePublicShareRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.dualcam.DualcamServicePromiseClient.prototype.revokePublicShare =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dualcam.DualcamService/RevokePublicShare',
      request,
      metadata || {},
      methodDescriptor_DualcamService_RevokePublicShare);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dualcam.SetItemContributorsRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_DualcamService_SetItemContributors = new grpc.web.MethodDescriptor(
  '/dualcam.DualcamService/SetItemContributors',
  grpc.web.MethodType.UNARY,
  proto.dualcam.SetItemContributorsRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.dualcam.SetItemContributorsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.dualcam.SetItemContributorsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dualcam.DualcamServiceClient.prototype.setItemContributors =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dualcam.DualcamService/SetItemContributors',
      request,
      metadata || {},
      methodDescriptor_DualcamService_SetItemContributors,
      callback);
};


/**
 * @param {!proto.dualcam.SetItemContributorsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.dualcam.DualcamServicePromiseClient.prototype.setItemContributors =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dualcam.DualcamService/SetItemContributors',
      request,
      metadata || {},
      methodDescriptor_DualcamService_SetItemContributors);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dualcam.ListAssignableUsersRequest,
 *   !proto.dualcam.AssignableUserList>}
 */
const methodDescriptor_DualcamService_ListAssignableUsers = new grpc.web.MethodDescriptor(
  '/dualcam.DualcamService/ListAssignableUsers',
  grpc.web.MethodType.UNARY,
  proto.dualcam.ListAssignableUsersRequest,
  proto.dualcam.AssignableUserList,
  /**
   * @param {!proto.dualcam.ListAssignableUsersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dualcam.AssignableUserList.deserializeBinary
);


/**
 * @param {!proto.dualcam.ListAssignableUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dualcam.AssignableUserList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dualcam.AssignableUserList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dualcam.DualcamServiceClient.prototype.listAssignableUsers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dualcam.DualcamService/ListAssignableUsers',
      request,
      metadata || {},
      methodDescriptor_DualcamService_ListAssignableUsers,
      callback);
};


/**
 * @param {!proto.dualcam.ListAssignableUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dualcam.AssignableUserList>}
 *     Promise that resolves to the response
 */
proto.dualcam.DualcamServicePromiseClient.prototype.listAssignableUsers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dualcam.DualcamService/ListAssignableUsers',
      request,
      metadata || {},
      methodDescriptor_DualcamService_ListAssignableUsers);
};


module.exports = proto.dualcam;

